import { get } from 'lodash'
import { dates, email, minLength, minNights, required } from 'utils/validation'
import { ACTIVITY_CATEGORIES, AJ_EVENT_TYPES, CONFIGURATION_KEYS, ROLES } from 'constants/enums'
import { isAssessorManagementEnabledForActivity } from '../../helpers/assessorHelper'


export default function(values = {}, props) {
  const orgId = get(props, 'activeOrganization.id')

  const isNew = get(values, 'id') === null || get(values, 'id') === undefined

  const isAssessorManagementEnabled = isNew ? get(props, `configuration.valuesByOrganizationId.${orgId}.${CONFIGURATION_KEYS.manageAssessors.id}.booleanValue`) :
    isAssessorManagementEnabledForActivity(values)

  let errors = {
    location: required(values.location && values.location.trim()),
    aim: required(values.aim),
    ajEventCategory: { value: required(get(values, 'ajEventCategory.value')) },
    modeOfTransportType: { value: required(get(values, 'modeOfTransportType.value')) },
    transportationModes:  required(get(values, 'transportationModes')) || minLength(1)(get(values, 'transportationModes')),
    activityCategory: { id: required(get(values, 'activityCategory.id')),
      parent: {
        id: required(get(values, 'activityCategory.parent.id'))
      }
    },
    awardLevel: { value: required(get(values, 'awardLevel.value')) },
    startDate: required(values.startDate),
    endDate: required(values.endDate) || dates(values.startDate)(values.endDate),
    assignToOrganizationId: required(values.assignToOrganizationId),
  }

  if(isAssessorManagementEnabled){
    const setupAssessorId = get(values, 'setupAssessorId')
    const assessorDataIsNeeded = setupAssessorId === 0
    errors.setupAssessorId = required(get(values, 'setupAssessorId'))
    errors.assessorTitle = assessorDataIsNeeded && required(get(values, 'assessorTitle'))
    errors.assessorName = assessorDataIsNeeded && required(get(values, 'assessorName'))
    errors.assessorEmail = assessorDataIsNeeded && required(get(values, 'assessorEmail'))
    errors.assessorPhone = assessorDataIsNeeded && required(get(values, 'assessorPhone'))

    errors.supervisorEmail = email(get(values, 'supervisorEmail'))
  } else {
    errors.assessorEmail = email(get(values, 'assessorEmail'))
    errors.supervisorEmail = email(get(values, 'supervisorEmail'))
  }

  if (
    get(props, 'ajEvents.detail.assessor') &&
    props.userType === ROLES.LEADER.u &&
    get(props, 'ajEvents.detail.assessorEmail') !== get(values, 'assessorEmail')
  ) {
    errors.reasonForChangingAssessor = required(
      values.reasonForChangingAssessor
    )
  }

  if (get(values, 'activityCategory.id') === ACTIVITY_CATEGORIES.other.id) {
    errors.otherName = required(get(values, 'otherName'))
  }

  if (
    get(values, 'startDate') <= get(values, 'endDate') &&
    get(props, 'values.ajEventCategory.value') ===
      AJ_EVENT_TYPES.qualification.id &&
    get(props, 'values.awardLevel.value', false)
  ) {
    errors.endDate = minNights(
      get(values, 'startDate'),
      get(values, 'endDate'),
      {
        awardLevelValue: get(props, 'values.awardLevel.value', false)
      }
    )
  }

  return errors
}
